<template>
  <router-view />
</template>

<script>
export default {
  name: 'clients-pages-container',
};
</script>
